interface MakerXLogoProps {
  className?: string;
  alt?: string;
}

export function MakerXLogo({ className, alt = "MakerX" }: MakerXLogoProps) {
  return (
    <img
      src="/makerx-logo.png"
      alt={alt}
      className={className}
      data-testid="makerx-logo"
    />
  );
}
